<template>
  <div class="min-h-full flex items-center justify-center mt-12">
    <div class="container-padded max-w-lg w-full shadow-md sm:p-12">
      <h2 class="text-center mb-4">
        <svg-vue
          icon="salesium-logo"
          class="w-8 inline-block mr-3"
        />
        Salesium
      </h2>
      <p class="text-center mb-5">Forgot your password?</p>

      <ValidationObserver
        ref="observer"
        v-slot="{ invalid }"
      >
        <form
          @submit.prevent="onSubmit"
          class="space-y-6"
        >
          <div>
            <ValidationProvider
              rules="required|email"
              v-slot="{classes, errors}"
            >
              <div
                class="control is-required"
                :class="classes"
              >
                <label for="email">Please enter the email associated with your account</label>
                <input
                  id="email-address"
                  name="email"
                  autocomplete="email"
                  type="email"
                  class="input-field block w-full"
                  required
                  v-model="email"
                  placeholder="Enter your email"
                  @click="clearValidationErrors"
                >
                <span class="text-red-500 text-hint">{{ errors[0] }}</span>
                <span v-if="validationErrors && validationErrors['email']" class="text-red-500 text-hint">{{ validationErrors['email'][0] }}</span>
              </div>
            </ValidationProvider>
          </div>
          <div class="text-center">
            <button
              type="submit"
              class="primary-btn mt-6 px-12"
              :disabled="invalid || isSubmitting"
            >
              Send Password Reset Email <span
                v-if="!invalid && isSubmitting"
                class="loading-spinner w-6 h-6 mt-2"
              ></span>
            </button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
export default {
  data() {
    return {
      email: '',
      errors: null,
      validationErrors: null,
      isSubmitting: false,
    };
  },
  methods: {
    async onSubmit() {
      this.isSubmitting = true;
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        const response = await window.axios.post('/api/forgot-password', {
          email: this.email.toLowerCase(),
        }).catch(err => {
          console.error('ERROR:', err.response.data.message);
          if (err.response.status === 422) {
            this.validationErrors = err.response.data.errors;
          }
        });

        if (response) {
          this.$toasted.global.toast_success(
            'Password reset email sent'
          );
        }
      }
      
      this.isSubmitting = false;
    },
    clearValidationErrors(event) {
      if (this.validationErrors && this.validationErrors[event.target.name]) {
        delete this.validationErrors[event.target.name];
      }
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
};
</script>

<style scoped>
.loading-spinner {
  display: inline-block;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: black;
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
  z-index: 10;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  /* width: 190px; */
}
</style>